/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 04:20 pm
 * Last Modified: Thursday, 24-11-14 03:16 pm, by Roger
 */

import { StyledComponent } from '@emotion/styled';

import { drawerClasses, DrawerProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { BaseDrawer } from '../../components/BaseDrawer';

export const StyledDrawer: StyledComponent<DrawerProps> = styled(BaseDrawer)(
  ({ theme }) => ({
    [`.${drawerClasses.paper}`]: {
      borderRadius: '16px 16px 0 0',
      maxHeight: 'calc(100vh - 106px)',
      [theme.breakpoints.only('xs')]: {
        paddingBottom: '34px',
      },
    },
  })
);
